export const CHECKOUT_URL =
  'https://mega-pack-cercos-electricos-y-seguridad-perimetral.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/cxbb4KA1NkKAHcniT3ygjR/Imagen_de_Codex_23_sept_2026,_19_41_18.png'

export const PRODUCT_NAME = 'MEGA PACK CERCOS ELÉCTRICOS Y SEGURIDAD PERIMETRAL'
export const PRICE = '$19.990'
export const BONUS_TOTAL = '$39.950'

export const META_PIXEL_ID = '2226605141499138'

/* 1. PROBLEMA */
export const problems = [
  {
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos sobre energizadores, aisladores, puesta a tierra, postes, cableado y mediciones, pero cada uno explica algo diferente y no sabes cómo conectar todo.',
  },
  {
    title: 'NO SABES QUÉ APRENDER PRIMERO',
    desc: 'Energizadores, conductores, aisladores, postes, puesta a tierra, alimentación, pruebas... hay tantos componentes y conceptos que empezar parece complicado.',
  },
  {
    title: 'TE FALTA UNA RUTA',
    desc: 'Quieres aprender una habilidad técnica que puedas convertir en un nuevo servicio, pero necesitas un camino que vaya desde los fundamentos hasta el diseño, instalación y diagnóstico.',
  },
  {
    title: 'SIGUES POSTERGANDO',
    desc: 'Quieres comenzar, pero pasan las semanas y continúas buscando información en lugar de avanzar con un método organizado.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'FUNDAMENTOS, FUNCIONAMIENTO Y SEGURIDAD',
    desc: 'Comprende cómo funciona un cerco eléctrico perimetral, sus principios fundamentales, componentes principales, conceptos eléctricos básicos, riesgos y criterios esenciales de seguridad.',
  },
  {
    title: 'COMPONENTES Y SELECCIÓN PROFESIONAL',
    desc: 'Conoce energizadores, conductores, aisladores, postes, soportes, tensores, puesta a tierra, alimentación, respaldo y los criterios necesarios para seleccionar correctamente cada componente.',
  },
  {
    title: 'DISEÑO, CÁLCULO Y PLANIFICACIÓN',
    desc: 'Aprende a realizar un relevamiento, analizar el perímetro, dividirlo en sectores, preparar croquis, calcular materiales y organizar el proyecto antes de comenzar la instalación.',
  },
  {
    title: 'INSTALACIÓN, CONFIGURACIÓN Y PUESTA EN SERVICIO',
    desc: 'Comprende el proceso de instalación, montaje, conexiones, configuración, inspección, pruebas y puesta en servicio siguiendo prácticas seguras y documentación técnica.',
  },
  {
    title: 'PRUEBAS, DIAGNÓSTICO Y MANTENIMIENTO',
    desc: 'Aprende un método ordenado para identificar síntomas, realizar verificaciones, localizar sectores problemáticos, analizar posibles causas, corregir fallas y organizar el mantenimiento.',
  },
  {
    title: 'INTEGRACIÓN, PRESUPUESTOS Y NEGOCIO',
    desc: 'Comprende cómo integrar conceptualmente el cerco con alarmas y CCTV, calcular costos, preparar presupuestos, documentar trabajos y comenzar a estructurar un servicio profesional.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: 'KIT PRO DEL INSTALADOR™',
    desc: '15 herramientas de campo para organizar relevamientos, seguridad, materiales, instalación, puesta en servicio, mediciones, diagnóstico, mantenimiento, informes y entrega profesional.',
    value: '$7.990',
  },
  {
    title: 'CERCO CALC PRO™',
    desc: 'Calculadora y planificador profesional para organizar perímetros, materiales, costos, mano de obra, presupuestos, compras y rentabilidad de cada proyecto.',
    value: '$5.990',
  },
  {
    title: 'DIAGNÓSTICO PRO™',
    desc: 'Método profesional de 7 pasos con árboles de decisión, fichas y herramientas para detectar, analizar, corregir, verificar y documentar fallas.',
    value: '$6.990',
  },
  {
    title: 'CERCO BUSINESS PRO™',
    desc: 'Plantillas y herramientas para organizar clientes, costos, presupuestos, órdenes de trabajo, adicionales, entregas, mantenimiento y rentabilidad.',
    value: '$8.990',
  },
  {
    title: 'ATLAS VISUAL PRO™',
    desc: 'Biblioteca visual de diagramas, croquis y casos para comprender componentes, diseñar perímetros, analizar fallas y documentar sistemas de seguridad perimetral.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'route' as const,
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre contenidos y sigue una ruta desde los fundamentos hasta el diseño, instalación, configuración, diagnóstico y mantenimiento.',
  },
  {
    icon: 'wrench' as const,
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprende energizadores, aisladores, postes, conductores, puesta a tierra, diseño, instalación, pruebas y diagnóstico con explicaciones organizadas.',
  },
  {
    icon: 'eye' as const,
    title: 'COMPRENDE LO QUE ESTÁS VIENDO',
    desc: 'Empieza a mirar un perímetro o un sistema instalado y reconocer qué componentes intervienen, cómo se relacionan y qué función cumple cada uno.',
  },
  {
    icon: 'zap' as const,
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construye conocimientos que pueden convertirse en el primer paso para incorporar un nuevo servicio técnico y ampliar tus posibilidades profesionales.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Había visto muchos videos sobre cercos eléctricos, pero seguía sin entender cómo se relacionaban el energizador, la puesta a tierra, los aisladores y el perímetro. Con los tomos ordenados finalmente pude comprender el sistema completo.',
    author: 'Diego Fernández',
    meta: 'Técnico en formación, 29 años · Rosario, Argentina',
  },
  {
    quote:
      'Lo que más me ayudó fue entender que instalar un cerco no es solamente colocar postes y conductores. Primero hay que relevar, diseñar, elegir componentes y verificar todo antes de poner el sistema en servicio.',
    author: 'Marcelo Ibáñez',
    meta: 'Instalador de seguridad, 41 años · Córdoba, Argentina',
  },
  {
    quote:
      'Trabajo con electricidad y quería sumar seguridad perimetral, pero no sabía qué estudiar primero. El sistema me ayudó a conectar la parte eléctrica con energizadores, puesta a tierra, alimentación, respaldo y pruebas.',
    author: 'Laura Quiroga',
    meta: 'Electricista, 35 años · Montevideo, Uruguay',
  },
  {
    quote:
      'Entré buscando aprender instalación y terminé entendiendo también diagnóstico. El método de 7 pasos me ayudó a pensar primero en el síntoma, después buscar evidencia y recién entonces determinar qué puede estar fallando.',
    author: 'Cristian Molina',
    meta: 'Técnico independiente, 32 años · Santiago, Chile',
  },
  {
    quote:
      'Quería agregar otro servicio a lo que ya hacía. Las plantillas, la calculadora y las herramientas para presupuestar me dieron una estructura mucho más clara para organizar cada proyecto.',
    author: 'Héctor Ramírez',
    meta: 'Instalador, 48 años · Guadalajara, México',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El sistema está organizado para comenzar desde los fundamentos y avanzar progresivamente hacia diseño, componentes, instalación, pruebas, diagnóstico y mantenimiento.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Aprenderás fundamentos de cercos eléctricos, energizadores, aisladores, postes, conductores, puesta a tierra, diseño del perímetro, instalación, configuración, pruebas, diagnóstico, mantenimiento, integración y presupuestos.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye recursos prácticos, diagramas, checklists, plantillas, casos y herramientas para ayudarte a aplicar los conceptos estudiados.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos GRATIS con tu compra durante esta oferta.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizas un único pago de $19.990. No hay mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Al completar tu compra recibirás acceso digital al contenido.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es un producto educativo y no reemplaza licencias, certificaciones, formación profesional, práctica supervisada ni otros requisitos exigidos en tu jurisdicción.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Puedes avanzar por los 6 tomos y utilizar los bonos siguiendo tu propio ritmo de aprendizaje.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes comunicarte a través del canal de soporte indicado al final de esta página.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — Argentina */
export const recentBuyers = [
  { name: 'Martín G.', city: 'Córdoba', minutes: 2 },
  { name: 'Sergio P.', city: 'Rosario', minutes: 5 },
  { name: 'Gabriel T.', city: 'Mendoza', minutes: 9 },
  { name: 'Ramiro L.', city: 'La Plata', minutes: 12 },
  { name: 'Lorena B.', city: 'Tucumán', minutes: 16 },
  { name: 'Walter D.', city: 'Mar del Plata', minutes: 21 },
  { name: 'Hernán C.', city: 'Neuquén', minutes: 25 },
  { name: 'Facundo R.', city: 'Salta', minutes: 31 },
  { name: 'Claudio M.', city: 'San Juan', minutes: 38 },
  { name: 'Emiliano V.', city: 'Bahía Blanca', minutes: 44 },
]
